<script lang="ts">
  /**
   * Inline loading / error line. Never a blank screen: a pulsing dot while
   * loading, a Finnish error with a retry button on failure.
   */
  let {
    loading = false,
    error = null,
    onretry,
    compact = false,
  }: {
    loading?: boolean;
    error?: string | null;
    onretry?: () => void;
    compact?: boolean;
  } = $props();
</script>

{#if loading}
  <div class="state" class:compact aria-busy="true" aria-label="Ladataan">
    <span class="dot"></span>
    {#if !compact}<span class="txt">Ladataan...</span>{/if}
  </div>
{:else if error}
  <div class="state err" class:compact role="alert">
    <span class="txt">{error}</span>
    {#if onretry}
      <button type="button" class="retry" onclick={onretry}>Yritä uudelleen</button>
    {/if}
  </div>
{/if}

<style>
  .state {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 28px 12px;
    color: var(--viisi-ink-2);
    font-size: 13px;
    text-align: center;
    flex-wrap: wrap;
  }
  .state.compact { padding: 10px 0; }
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--viisi-accent);
    animation: pulse 1.4s ease-in-out infinite;
  }
  .err .txt { color: var(--viisi-bad); font-weight: 600; }
  .retry {
    padding: 7px 12px;
    border-radius: var(--viisi-radius-sm);
    background: var(--viisi-accent-soft);
    color: var(--viisi-accent);
    font-weight: 700;
    font-size: 13px;
  }
  @keyframes pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.35; transform: scale(0.85); }
  }
</style>
